import React from 'react';
import EditInteractionModal from '../EditInteractionModal';
import DocumentDetailsModal from '@/modules/documents/details/DocumentDetailsModal';
import ShareItemModal from '@/shared/components/ShareItemModal';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import SingleRelationMailModal from '@/shared/components/email/SingleRelationMailModal';
import YesNoModal from '@/shared/components/YesNoModal';
import messages from '../interactionMessages';

const InteractionModals = ({ type, interaction, intl, onSave, onClose, ...otherProps }) => {
  switch (type) {
    case 'editInteraction':
      return (
        <EditInteractionModal
          interactionId={interaction.id}
          intl={intl}
          onSave={onSave}
          onClose={onClose}
          {...otherProps}
        />
      );
    case 'openMail':
      return (
        <DocumentDetailsModal
          show
          documentId={interaction.objectId}
          allowNavigation={false}
          intl={intl}
          onSave={onSave}
          onClose={onClose}
          {...otherProps}
        />
      );
    case 'shareInteraction':
      return (
        <ShareItemModal
          show
          type="interaction"
          id={interaction.id}
          relationId={interaction.relationId}
          relationName={interaction.relationName}
          itemName={`${intl.formatMessage(
            listItemMsg('InteractionType', interaction.interactionType),
          )} - ${interaction.title}`}
          onSave={onSave}
          onClose={onClose}
          {...otherProps}
        />
      );
    case 'sendViaEmail':
      return (
        <SingleRelationMailModal
          intl={intl}
          show
          relationId={interaction.relationId}
          emailContext={13}
          onSave={onSave}
          onClose={onClose}
          {...otherProps}
        />
      );
    case 'deleteInteraction':
      return (
        <YesNoModal
          intl={intl}
          show
          title={intl.formatMessage(messages.Delete)}
          message={intl.formatMessage(messages.DeleteInteractionConfirmationMsg)}
          onNo={onClose}
          onSave={onSave}
        />
      );
    default:
      return null;
  }
};
export default InteractionModals;
